import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { ReportsService } from '../../../../services/reports.service';
import { Router, RouterModule } from '@angular/router';
import { saveAs } from 'file-saver';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { CommonService } from '../../../../services/common.service';
@Component({
    selector: 'app-inspections-look-ahead-report',
    imports: [DropdownModule, TableModule, RouterModule, FormsModule, CommonModule, CheckboxModule],
    templateUrl: './inspections-look-ahead-report.component.html',
    styleUrl: './inspections-look-ahead-report.component.scss'
})
export class InspectionsLookAheadReportComponent {

  inspectionLookAheadData: any;
  reportData: any
  userCAI: string = ''
  isShowMainBlock: boolean = false;
  facilityId: string = '';
  isLoading: boolean = false;

  constructor(private reports: ReportsService, private router: Router,
    public commonService: CommonService
  ) { 
    this.userCAI = this.commonService.getUserCai();
  }
  ngOnInit() {
    this.facilityId = localStorage.getItem('current_facility_id') || 'ES';
    this.getInspectionLookAheadBuildSearch(this.facilityId, false);
  }


  filters:any = {
    days: 30,
    repairtype: 'ALL',
    plants: 'ALL',
    associatedPlants: 'ALL',
    divisions: 'ALL',
    sections: 'ALL',
  }
  days = [
    { label: '30 days', value: '30' },
    { label: '60 days', value: '60' },
    { label: '90 days', value: '90' }
  ];
  repairtype = [];
  divisions = [];
  plant = [];
  sections = [];
  plants = [];
  associatedPlants = [];

  getInspectionLookAheadBuildSearch(facilityId: string, isRetired: boolean): void {
    this.isLoading = true;
    this.reports.getInspectionsLookAheadBuildSearch(this.facilityId, isRetired).subscribe(
      (data: any) => {
        this.inspectionLookAheadData = data;
      this.isLoading = false;
        this.repairtype = data.repairTypeItems;
        this.divisions = data.divisionItems;
        this.sections = data.sectionItems;
        this.plants = data.plantItems;
        this.associatedPlants = data.associatedPlantItems;
      },
      (error: any) => {
        console.error('Error fetching air compliance details', error);
      }
    );
  }

  runReport() {
    const { days, repairtype, divisions, sections, plants, associatedPlants } = this.filters;
    this.reports.runReport(
      this.facilityId,
      this.userCAI,
      days,
      repairtype,
      divisions,
      sections,
      plants,
      associatedPlants
    ).subscribe(
      data => {
        this.reportData = data;
        this.isShowMainBlock = true;
      },
      error => {
        console.error('Error fetching report data:', error);
      }
    );
  }


  exportToExcel() {

    const { days, repairtype, divisions, sections, plants, associatedPlants } = this.filters;
    let params = {
      facilityID: localStorage.getItem('current_facility_id') || 'ES',
      userCAI: this.userCAI,
      dateRange: days,
      repairType: repairtype,
      division: divisions,
      section: sections,
      plant: plants,
      associatedPlant: associatedPlants
    };


    this.reports.getInspectionsLookAheadBuildSearchExcel(params)
      .subscribe({
        next: (fileData: any) => {
          if (fileData) {
            saveAs(fileData, 'Inspection look ahead report.xlsx');
          }
        },
        error: (err: any) => {
          console.error('Error fetching report details:', err);
        }
      });

  }
}
